import { LogicContext } from '@/logic/main/types';
import { isIframeWrapperEnabled } from '@/logic/main/utils';

export const setHeaderProperties = async (
  context: LogicContext,
  event: { mainLayoutPath: string; pageTitle: string }
) => {
  if (!isIframeWrapperEnabled()) {
    return {
      updates: [],
    };
  }

  return {
    updates: [
      {
        type: 'setLayoutProperty',
        data: {
          path: 'components.Header.properties',
          value: {
            ...(!!event.pageTitle && {
              title: event.pageTitle,
            }),
          },
        },
      },
      {
        type: 'hideLayoutComponent',
        data: 'PageHeader',
      },
    ],
  };
};
